import { motion } from "framer-motion";

const steps = [
  { n: "01", t: "Consultation & Discovery", d: "We listen, ask sharp questions and map your business to a digital strategy." },
  { n: "02", t: "Planning & Strategy", d: "Scope, architecture, tech stack and a clear delivery roadmap." },
  { n: "03", t: "Design & Prototyping", d: "Wireframes → high-fidelity prototypes you can click before we code." },
  { n: "04", t: "Development", d: "Modern frameworks, clean code, automated testing — built to last." },
  { n: "05", t: "Quality Assurance", d: "Cross-device, cross-browser, performance and security audits." },
  { n: "06", t: "Launch & Deployment", d: "Smooth release with CI/CD, monitoring and analytics baked in." },
  { n: "07", t: "Maintenance & Support", d: "Ongoing care so your product keeps performing at its best." },
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="relative py-32 lg:py-44 px-6 lg:px-10 border-t border-nova-line overflow-hidden">
      <div className="orb orb-gold w-[420px] h-[420px] top-40 right-1/4 opacity-20" />
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="mb-20 max-w-3xl">
          <div className="mono-label mb-4">[ 02 — How we work ]</div>
          <h2 className="font-display font-bold tracking-tighter text-4xl lg:text-6xl text-nova-text leading-[0.95]">
            A 7-step ritual for <span className="gold-text italic font-light">flawless</span> delivery.
          </h2>
        </div>

        <div className="relative grid lg:grid-cols-12">
          {/* Vertical timeline rail */}
          <div className="hidden lg:block absolute left-[10%] top-0 bottom-0 w-px bg-nova-line">
            <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-nova-gold via-nova-gold/50 to-transparent animate-beam" />
          </div>

          <div className="lg:col-start-2 lg:col-span-11 space-y-14">
            {steps.map((s, i) => (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, x: -24 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.55, delay: i * 0.05 }}
                data-testid={`process-step-${s.n}`}
                className="grid grid-cols-12 gap-6 lg:gap-10 items-start relative pl-2 lg:pl-12"
              >
                <span className="hidden lg:block absolute -left-[7px] top-3 w-3 h-3 rotate-45 bg-nova-bg border border-nova-gold" />
                <div className="col-span-12 lg:col-span-2">
                  <span className="font-display font-light text-6xl lg:text-7xl text-white/10">{s.n}</span>
                </div>
                <div className="col-span-12 lg:col-span-10 pt-2">
                  <h3 className="font-display font-medium text-2xl lg:text-3xl text-nova-text mb-3 tracking-tight">
                    {s.t}
                  </h3>
                  <p className="text-nova-mute text-base lg:text-lg max-w-2xl leading-relaxed">
                    {s.d}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
